import firebase from "../config/Firebase/index";

export const fetchUsers = async () => {
	let usersList = [];
	return await firebase
		.database()
		.ref()
		.child("users")
		.get()
		.then(function (data) {
			if (data.exists()) {
				usersList = extractUsers(data.val());
				return usersList;
			}
			else {
				console.log("No data available");
			}
		})
		.catch(function (error) {
			console.error(error);
		});
}

export const extractUsers = (data) => {
	let apps = [];
	for (let key in data) {
		data[key].userId = key;
		apps.push(data[key]);
	}
	return apps || [];
};